import { Navigate, useLocation, useNavigate } from "react-router";
export default function Success() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }
  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">Thank you</h1>
      <h2 className="text-red mx-auto mb-6 max-w-xs text-center font-bold">
        Thanks for entering your details
      </h2>
      <p className="text-red mx-auto mb-6 max-w-xs text-center">
        We’ll send you an email to your inbox shortly, make sure you follow the
        link to activate your entry. 
      </p>
      <p className="text-red mx-auto mb-6 max-w-xs text-center">
        If it’s not come through, please check your junk folder.{" "}
      </p>
      <p className="text-red mx-auto mb-8 max-w-xs text-center">
        To find your nearest Costa Express machine, check out our map here.{" "}
      </p>
      <button
        onClick={() => {
          navigate("/locations");
        }}
        type="button"
        className="btn"
      >
        Locations
      </button>
    </div>
  );
}
